import { render, staticRenderFns } from "./ScansModal.vue?vue&type=template&id=13135552&scoped=true&"
import script from "./ScansModal.vue?vue&type=script&lang=js&"
export * from "./ScansModal.vue?vue&type=script&lang=js&"
import style0 from "./ScansModal.vue?vue&type=style&index=0&id=13135552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13135552",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13135552')) {
      api.createRecord('13135552', component.options)
    } else {
      api.reload('13135552', component.options)
    }
    module.hot.accept("./ScansModal.vue?vue&type=template&id=13135552&scoped=true&", function () {
      api.rerender('13135552', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/compliance/ScansModal.vue"
export default component.exports